@if (active) {
  <div class="py-4">
    <ng-content></ng-content>
  </div>
}
